import { render, staticRenderFns } from "./org-section.vue?vue&type=template&id=0236bc05&scoped=true&"
import script from "./org-section.vue?vue&type=script&lang=js&"
export * from "./org-section.vue?vue&type=script&lang=js&"
import style0 from "./org-section.vue?vue&type=style&index=0&id=0236bc05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236bc05",
  null
  
)

export default component.exports